export default __webpack_public_path__ + "static/media/404_Error.667c883a.jpg";